import React from 'react';
import { PictoProps } from './index';

export const PadlockOpen = (props: PictoProps) => (
  <svg
    width={props.width || '21'}
    height={props.height || '23'}
    viewBox="0 0 21 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.44434"
      y="10.616"
      width="18"
      height="11"
      rx="2"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.44434 10.6159V6.61591C5.44176 4.04714 7.38608 1.89435 9.94184 1.6362C12.4976 1.37804 14.8332 3.09851 15.3443 5.61591"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
